export default {
  BASE_URL: "/sob/operation",
  api: [
    {
      name: "list",
      path: "/list",
      method: "POST",
      desc: "综合列表"
    },
    {
      name: "rateList",
      path: "/convertion/rate/list",
      method: "POST",
      desc: "订单转化率列表"
    },
    {
      name: "rateListExport",
      path: "/order/rate/export",
      method: "POST",
      desc: "订单转化率列表导出"
    },
    {
      name: "exportExcel",
      path: "/exportExcel",
      method: "POST",
      desc: "综合列表excel"
    },
    {
      name: "exportRateExcel",
      path: "/convertion/rate/exportExcel",
      method: "POST",
      desc: "转化率列表excel"
    },
    {
      name: "orderList",
      path: "/order/rate/list",
      method: "POST",
      desc: "转化率列表"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/operation.js